import { render } from "./DraftPreviewTable.vue?vue&type=template&id=5a1a724f&scoped=true&ts=true"
import script from "./DraftPreviewTable.vue?vue&type=script&lang=ts"
export * from "./DraftPreviewTable.vue?vue&type=script&lang=ts"

import "./DraftPreviewTable.vue?vue&type=style&index=0&id=5a1a724f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1a724f"]])

export default __exports__